import type { AcuityScore } from "@/core/types";
import { AcuityScoreBadge } from "@/features/acuity/components/AcuityScoreBadge";
import { cn } from "@/lib/helpers/cn";
import IconArrow from "@/assets/images/icons2/icon--arrow.svg?component";

type AcuityScoreChangeProps = {
  className?: string;
  currentScore: AcuityScore;
  isLabelled?: boolean;
  newScore: AcuityScore;
};

export function AcuityScoreChange({
  className,
  currentScore,
  isLabelled,
  newScore,
}: AcuityScoreChangeProps) {
  return (
    <div className={cn("tw:flex tw:items-center tw:gap-2", className)}>
      <AcuityScoreBadge acuityScore={currentScore} />
      <IconArrow className="tw:text-fill-tertiary" />
      <AcuityScoreBadge acuityScore={newScore} isLabelled={isLabelled} />
    </div>
  );
}
